import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { AmountBreakdown, BillingDashBoardBillAccount } from '@amfam/shared/models';
import { CopyService } from '@amfam/shared/utility/shared-services';

import { CommonFeatureFacade } from '../../+state/common.facade';

@Component({
  selector: 'ds-billing-dashboard-wrapper',
  templateUrl: './billing-dashboard-wrapper.component.html',
  styleUrls: ['./billing-dashboard-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BillingDashboardWrapperComponent implements OnInit, OnDestroy {
  dashboardHeading: string;
  dataLoading$: Observable<boolean>;
  loadingMessage: string;
  manualPaymentTotal$: Observable<AmountBreakdown>;
  autopayOrAFTTotal$: Observable<AmountBreakdown>;
  billingTileAccountsList$: Observable<BillingDashBoardBillAccount[]>;
  webSlicedLength = 4;
  mobileSlicedLength = 3;

  private stop$ = new Subject<void>();

  constructor(
    private copyService: CopyService,
    private commonFacade: CommonFeatureFacade
  ) {}

  ngOnInit(): void {
    this.dashboardHeading = this.copyService.getCopy('billing.billingDashboard.heading');
    this.loadingMessage = this.copyService.getCopy('billing.billingDashboard.loadingMessage');
    this.dataLoading$ = this.commonFacade.dataLoading();
    this.manualPaymentTotal$ = this.commonFacade.calculateManualPaymentTotal();
    this.autopayOrAFTTotal$ = this.commonFacade.calculateAutopayOrAFTTotal();
    this.billingTileAccountsList$ = this.commonFacade.getBillingTileAccountsList();
  }

  toggleBillingTileListWeb(): number {
    let billingTileAccountsListLength: number;
    this.billingTileAccountsList$.subscribe(list => (billingTileAccountsListLength = list.length));
    this.webSlicedLength =
      this.webSlicedLength === billingTileAccountsListLength ? 4 : billingTileAccountsListLength;
    return this.webSlicedLength;
  }

  toggleBillingTileListMobile(): number {
    let billingTileAccountsListLength: number;
    this.billingTileAccountsList$.subscribe(list => (billingTileAccountsListLength = list.length));
    this.mobileSlicedLength =
      this.mobileSlicedLength === billingTileAccountsListLength ? 3 : billingTileAccountsListLength;
    return this.mobileSlicedLength;
  }

  billingTileClicked() {
    document.activeElement.parentElement.classList.add('activeState');
    setTimeout(function () {
      document.activeElement.parentElement.classList.remove('activeState');
    }, 200);
  }

  ngOnDestroy() {
    this.stop$.next();
    this.stop$.complete();
  }
}
